import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCO_sDrT9nS9shtPuuw1tmuVUGRBt11DJ8',
  authDomain: 'sint-projetos.firebaseapp.com',
  projectId: 'sint-projetos',
  storageBucket: 'sint-projetos.firebasestorage.app',
  messagingSenderId: '504664217284',
  appId: '1:504664217284:web:87b8d96ac8bbd3731fdb91',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
